var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2985 12.6879C10.2985 13.2268 9.86122 13.6641 9.32241 13.6641C8.78361 13.6641 8.34634 13.2268 8.34634 12.6879V3.33426L5.13454 6.5473C4.75308 6.9288 4.13562 6.9288 3.75416 6.5473C3.37361 6.16581 3.37361 5.54828 3.75416 5.1677L8.60523 0.316164C8.7827 0.123128 9.03884 0.00143909 9.32241 0.00143909C9.46969 0.00143909 9.60875 0.0343742 9.73314 0.0920124C9.83468 0.139584 9.92982 0.204539 10.0131 0.287792L14.8915 5.16767C15.273 5.54825 15.273 6.16578 14.8915 6.54727C14.511 6.92877 13.8926 6.92877 13.5121 6.54727L10.2984 3.33329L10.2985 12.6879Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.954333 10.6289C1.48116 10.6289 1.90871 11.0419 1.90871 11.5508V15.2367C1.90871 15.4812 2.00889 15.7162 2.18779 15.889C2.36669 16.0618 2.60906 16.1586 2.8622 16.1586H16.2198C16.473 16.1586 16.7154 16.0618 16.8942 15.889C17.0731 15.7162 17.1733 15.4812 17.1733 15.2367V11.5508C17.1733 11.0419 17.6009 10.6289 18.1277 10.6289C18.6545 10.6289 19.0821 11.0419 19.0821 11.5508V15.2367C19.0821 15.9702 18.7806 16.6735 18.2431 17.1919C17.7064 17.7104 16.9783 18.0015 16.2199 18.0015H2.86222C2.10373 18.0015 1.37565 17.7104 0.838997 17.1919C0.301426 16.6735 0 15.9702 0 15.2367V11.5508C0 11.0419 0.427501 10.6289 0.954333 10.6289Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b837223d8f98c8b012724e06019dcb29.svg";
export { ForwardRef as ReactComponent };